// ── Phone helpers ────────────────────────────────────────────────
// Consistent phone-number normalization + tel: link building used by the
// Inquiries table, Client dialog, etc. 8x8 Work for Desktop registers
// itself as the default `tel:` handler, so click-to-dial routes to the
// 8x8 app automatically on any workstation with it installed.
export function normalizePhone(raw) {
  if (!raw) return '';
  let s = String(raw).trim();
  const hasPlus = s.startsWith('+');
  s = s.replace(/[^\d]/g, '');
  if (!s) return '';
  if (!hasPlus && s.length === 10) return `+1${s}`;
  if (!hasPlus && s.length === 11 && s.startsWith('1')) return `+${s}`;
  return hasPlus ? `+${s}` : s;
}

export function buildTelUri(phone) {
  const p = normalizePhone(phone);
  return p ? `tel:${p}` : '';
}

// Pretty-print for display, e.g. "+12813001234" → "(281) 300-1234"
export function formatPhoneDisplay(raw) {
  const p = normalizePhone(raw);
  if (!p) return '';
  const digits = p.replace(/^\+/, '');
  const local = digits.length === 11 && digits.startsWith('1') ? digits.slice(1) : digits;
  if (local.length !== 10) return raw; // give up gracefully on non-US formats
  return `(${local.slice(0, 3)}) ${local.slice(3, 6)}-${local.slice(6)}`;
}
